import { getAuth } from 'firebase/auth'
import { REACT_APP_DATABASE_HOST } from '../constants/config'

/**
 * Fetches data through a proxy endpoint
 * @param {Object} params - The parameters for the proxy request
 * @param {string} params.url - The URL to fetch (required)
 * @param {('GET'|'POST')} [params.method='GET'] - The HTTP method to use
 * @param {Object} [params.body={}] - The request body for POST requests
 * @param {boolean} [params.apiBuenosAires=false] - Whether to add client credentials to URL
 * @param {Object} [params.headers={}] - The headers to send with the request
 * @returns {Promise<Response>} The fetch response
 * @throws {Error} If URL is undefined or invalid method is provided
 */
const fetchProxy = async ({ url, method = 'GET', body = {}, apiBuenosAires = false, headers }) => {
  if (!url) {
    throw new Error('URL parameter is required')
  }

  if (!['GET', 'POST'].includes(method)) {
    throw new Error('Method must be either GET or POST')
  }

  const auth = getAuth()
  const user = auth.currentUser
  const token = await user.getIdToken()

  const reqConfig = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`
    },
    body: JSON.stringify({
      url,
      method,
      body,
      api_buenos_aires: apiBuenosAires,
      headers
    })
  }

  return fetch(`${REACT_APP_DATABASE_HOST}/proxy`, reqConfig)
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      return response.json()
    })
}

export default fetchProxy
